import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";

const ClientCardSkeleton = () => (
	<Card sx={{ height: "100%" }}>
		<CardContent>
			<Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
				<Skeleton variant="circular" width={48} height={48} />
				<Stack spacing={0.5} sx={{ flex: 1 }}>
					<Skeleton variant="text" width={140} height={24} />
					<Skeleton variant="text" width={100} height={16} />
				</Stack>
			</Box>
			<Stack spacing={1}>
				<Skeleton variant="text" width="80%" height={18} />
				<Skeleton variant="text" width="60%" height={18} />
				<Skeleton variant="text" width="70%" height={18} />
			</Stack>
		</CardContent>
	</Card>
);

const SKELETON_KEYS = ["a", "b", "c", "d", "e", "f", "g", "h", "i"];

const ClientsPageSkeleton = () => (
	<Box sx={{ width: "100%", pt: 2 }}>
		<Box sx={{ mb: 2 }}>
			<Skeleton variant="rectangular" height={56} sx={{ borderRadius: 1 }} />
		</Box>
		<Grid container spacing={2}>
			{SKELETON_KEYS.map((key) => (
				<Grid size={{ xs: 12, sm: 6, lg: 4 }} key={key}>
					<ClientCardSkeleton />
				</Grid>
			))}
		</Grid>
	</Box>
);

export default ClientsPageSkeleton;
